import React, { createContext, useEffect, useState } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import PrivateRoutes from "../../Navigation/PrivateRoutes/PrivateRoutes";
import LeaderRoutes from "../Leader/LeaderRoutes/LeaderRoutes";
import ParentRoutes from "../Parent/ParentRoutes/ParentRoutes";
import Login from "../Login/Login";
import Verification from "../Verification/Verification";
import AdminRoutes from "../Admin/AdminRoutes/AdminRoutes";
import MaintenanceNotice from "../MaintenanceNotice/MaintenanceNotice";
import ResetPassword from "../ResetPassword/ResetPassword";
import EmergencyPayment from "../EmergencyPayment/EmergencyPayment";
import EmergencyPaymentStatus from "../EmergencyPayment/EmergencyPaymentStatus/EmergencyPaymentStatus";
import { MaintenanceAPIs } from "../../../API/MaintenanceAPIs/MaintenanceAPIs";
import PortalFooter from "../PortalFooter/PortalFooter";

export const AccountContext = createContext();
export const GetMaintenanceContext = createContext();

function PageRoutes() {

    const routeParams = useParams();
    const [loading, setLoading] = useState(true);
    const [isParent, setIsParent] = useState(true);
    const [verified, setVerified] = useState(false);

    const [accountDetails, setAccountDetails] = useState();
    const maintenance = false;
    const [maintenanceData, setMaintenanceData] = useState({});
    
    const getMaintenanceStatus = async () => {
        //Fetch details from DB
        try{
            const response = (await MaintenanceAPIs.GetMaintenanceMode()).data;
            setMaintenanceData(response.data);
        }
        catch (err){
            console.log(err);
            
        }
        finally{
            setLoading(false);
        }
    }

    useEffect(() => {
        getMaintenanceStatus();
    }, []);

    useEffect(() => {
        getMaintenanceStatus();
        console.log(routeParams);
    }, [routeParams.userID]);

    if(!loading){
        return (
            <>
            <GetMaintenanceContext.Provider value={getMaintenanceStatus}>
            <AccountContext.Provider value={{accountDetails, setAccountDetails}}>
            <Routes>
                {/* {maintenance ? <Route exact path={'/*'} element={<MaintenanceNotice maintenanceData={maintenanceData}/>}/>: */}
                {maintenanceData.status === 1 ? <Route exact path={'/*'} element={<MaintenanceNotice maintenanceData={maintenanceData}/>}/>:
                <>
                <Route exact path={'/*'} element={<Login setIsParent={setIsParent} />} />
                <Route element={<PrivateRoutes isParent={isParent} setIsParent={setIsParent} setVerified={setVerified} />}>
                    <Route exact path={'/:userID/*'} element={isParent ? <ParentRoutes verified={verified}/> : <LeaderRoutes />} />
                </Route>
                <Route exact path={'/verify/:verificationCode'} element={<Verification/>}/>
                <Route exact path={'/emergency/:emergencyPaymentCode'} element={<EmergencyPayment/>}/>
                <Route exact path={'/emergency/payment/:status'} element={<EmergencyPaymentStatus/>}/>
                <Route exact path={'/reset-password/:resetToken'} element={<ResetPassword/>}/>
                </>
                }
                <Route exact path={'/admin/*'} element={<AdminRoutes/>}/>
            </Routes>
            </AccountContext.Provider>
            </GetMaintenanceContext.Provider>
            {/* {maintenanceData.status !== 1 && <PortalFooter/>} */}
            </>
        )   
    }
}
export default PageRoutes;

